import React, { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'
import XOEasyMode from '../components/XOGame/XOEasyMode';
import XOMediumMode from '../components/XOGame/XOMediumMode';
import XOHardMode from '../components/XOGame/XOHardMode';
import DailyGamePlayGate from '../components/DailyGamePlayGate';

const XOGamePlay = () => {
    const location = useLocation();
    const [level, setLevel] = useState(null);
    useEffect(() => {
        setLevel(location?.state?.level);
    }, [location?.state]);
    let game = null;
    switch (String(level)) {
            case "1":
                game = <XOEasyMode />;
                break;

            case "2":
                game = <XOMediumMode />;
                break;
            case "3":
                game = <XOHardMode />;
                break;
            default: return null
    }

    return (
        <DailyGamePlayGate gameName="X-O Game" levelId={level}>
            {game}
        </DailyGamePlayGate>
    );
}

export default XOGamePlay